import React from "react";
import { Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AppSettings } from "./../../config/app-settings.js";
import useThemeColor from "../../hooks/useThemeColor.js";
import useDarkMode from "../../hooks/useDarkMode.js";
import SidebarMinifyBtn from "./sidebar-minify-btn.jsx";
import SidebarNav from "./sidebar-nav.jsx";

function Sidebar() {
  const themeColor = useThemeColor();
  const appDarkMode = useDarkMode();
  const accent = themeColor || "#30D6A4";

  return (
    <AppSettings.Consumer>
      {({
        toggleAppSidebarMobile,
        appSidebarTransparent,
        appSidebarGrid,
        appSidebarLight,
      }) => {
        // Follow app light/dark mode; ThemePanel "sidebar light" can still force light.
        const sidebarLight = appSidebarLight || !appDarkMode;
        const themeAttr = sidebarLight ? undefined : "dark";

        return (
          <React.Fragment>
            <div
              id="sidebar"
              className={
                "app-sidebar " +
                (appSidebarTransparent ? "app-sidebar-transparent " : "") +
                (appSidebarGrid ? "app-sidebar-grid " : "") +
                (sidebarLight ? "app-sidebar-light " : "")
              }
              data-bs-theme={themeAttr}
              style={{
                "--sidebar-accent": accent,
                "--sidebar-accent-soft": `${accent}24`,
                "--sidebar-accent-softer": `${accent}14`,
                "--sidebar-accent-mid": `${accent}38`,
                "--sidebar-accent-shadow": `${accent}40`,
              }}
            >
              <PerfectScrollbar
                className="app-sidebar-content"
                options={{ suppressScrollX: true }}
              >
                <SidebarNav />
                <SidebarMinifyBtn />
              </PerfectScrollbar>
            </div>
            <div
              className={
                "app-sidebar-bg" + (sidebarLight ? " app-sidebar-light" : "")
              }
              data-bs-theme={themeAttr}
            />
            <div className="app-sidebar-mobile-backdrop">
              <Link
                to="/"
                onClick={toggleAppSidebarMobile}
                className="stretched-link"
              />
            </div>
          </React.Fragment>
        );
      }}
    </AppSettings.Consumer>
  );
}

export default Sidebar;
